import React from 'react';
import { Table } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';

export default function ActualTable({
  projectActualDetails,
  actualDetailsTotals
}) {
  const generateTotalsRow = () => {
    return (
      <tr>
        <td>Totals</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalMandays)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalRevenue)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalFullyLoadedCost)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalUnloadedCost)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalExternalCost)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalTotalCost)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalProfitBeforeTax)}</td>
        <td className="align-right totals-actual">{toMonetaryFormat(actualDetailsTotals.totalProfitNetofTax)}</td>
      </tr>
    )
  }

  return (
    <Table>
      <thead>
        <tr>
          <th className="align-center remove-th-style"></th>
          <th className="align-center">Total Mandays</th>
          <th className="align-center">Total Revenue</th>
          <th className="align-center">Fully Loaded Cost</th>
          <th className="align-center">Unloaded Cost</th>
          <th className="align-center">Other Cost</th>
          <th className="align-center">Total Cost</th>
          <th className="align-center">Profit Before Tax</th>
          <th className="align-center">Profit after Tax</th>
        </tr>
      </thead>
      <tbody>
        { projectActualDetails }
        { generateTotalsRow() }
      </tbody>
    </Table>
  )
}

